<mat-sidenav-container class="sidenav-container" >
  <mat-sidenav #drawer class="sidenav" [class.sidenav-collapsed]="soloIconos" fixedInViewport="true" [fixedTopGap]="0"
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="!(isHandset$ | async) && viewSidenav" >

    <!-- CABECERA DEL MENÚ -->
    <div class="sidenav-logo-area">
      <a [routerLink]="'/'">
      <img *ngIf="!soloIconos" src="assets/images/blanco.png" alt="Logo Seguros Caroni" class="logo-img">
      <img *ngIf="soloIconos" src="assets/images/caroblanco.png" alt="Logo Mini" class="logo-img">
      </a>
    </div>

    <div class="linea"></div>

    <div class="toggle-container">
      <button *ngIf="viewSidenav" mat-icon-button (click)="onMenuClick()">
      <!-- <button *ngIf="viewSidenav" mat-icon-button (click)="drawer.toggle()"> -->
        <mat-icon>menu</mat-icon>
      </button>
    </div>

    <!-- BIENVENIDA -->
    <div class="sidenav-menu-area" >
      <ng-container *ngIf="!soloIconos">
        <div class="welcome-area" *ngFor="let usuario of datos">
          <div class="welcome-info-row">
            <img class="avatar-img" src="assets/images/user.png" alt="Avatar" />
            <div class="welcome-info-text">
              <div class="welcome-title">¡Bienvenido!</div>
              <div class="welcome-user">{{ usuario.NOMBRE }}</div>
              <div class="welcome-user">Fecha: {{ today }}</div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- OPCIONES DEL MENÚ -->
    <mat-nav-list>
      <mat-accordion>
        <!-- <a mat-list-item [routerLink]="'/'">
          <mat-icon>home</mat-icon>
          <span *ngIf="!soloIconos">Inicio</span>
        </a> -->
        <mat-expansion-panel *ngIf="tienePermiso('WSPOLI20')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>verified_user</mat-icon>
              <span *ngIf="!soloIconos">Pólizas</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list *ngIf="!soloIconos">
            <a mat-list-item [routerLink]="'/insurance-policy'" *ngIf="tienePermiso('CSEGPO20')">
              <mat-icon>description</mat-icon>
              <span>Consulta de pólizas</span>
            </a>
            <a mat-list-item [routerLink]="'/control-documents'" *ngIf="tienePermiso('CSEGDO20')">
              <mat-icon>folder</mat-icon>
              <span>Control de documentos</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="tienePermiso('WSCPEM20')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>request_quote</mat-icon>
              <span *ngIf="!soloIconos">Cotizar/Emitir </span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list *ngIf="!soloIconos">
            <a mat-list-item [routerLink]="'/funeral-quote'" class="letras" *ngIf="tienePermiso('POLFUN20')">
              <mat-icon>how_to_reg</mat-icon>
              <span>Pólizas de funerario</span>
            </a>
            <a mat-list-item [routerLink]="'/hcm-quote'" class="letras" *ngIf="tienePermiso('POLHCM20')">
              <mat-icon>how_to_reg</mat-icon>
              <span>Pólizas de HCM</span>
            </a>
            <a mat-list-item [routerLink]="'/car-quote'" class="letras" *ngIf="tienePermiso('POLAUT20')">
              <mat-icon>how_to_reg</mat-icon>
              <span>Pólizas de automóvil</span>
            </a>
            <a mat-list-item [routerLink]="'/quotes-consultation'" class="letras" *ngIf="tienePermiso('EMIHCM20')">
              <mat-icon>how_to_reg</mat-icon>
              <span>Emisión persona</span>
            </a>
            <a mat-list-item [routerLink]="'/quotesa-consultation'" class="letras" *ngIf="tienePermiso('EMIAUT20')">
              <mat-icon>how_to_reg</mat-icon>
              <span>Emisión RCV</span>
            </a>
            <a mat-list-item [routerLink]="'/simply-emicar'" class="letras" *ngIf="tienePermiso('EMIRCV20')">
              <mat-icon>how_to_reg</mat-icon>
              <span>Poliza & Emision RCV</span>
            </a>
            <a mat-list-item [routerLink]="'/edit-policy'" class="letras" *ngIf="tienePermiso('EDIRCV20')">
              <mat-icon>how_to_reg</mat-icon>
              <span>Editar Póliza RCV</span>
            </a>
           <a mat-list-item [routerLink]="'/emision-directa-person'" *ngIf="currentUserCode === '11663742'" class="letras" >
              <mat-icon>how_to_reg</mat-icon>Emisión directa persona
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="tienePermiso('WFPAGT20')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>credit_card</mat-icon>
              <span *ngIf="!soloIconos">Pagos</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list *ngIf="!soloIconos">
            <a mat-list-item [routerLink]="'/payment'" *ngIf="tienePermiso('BOTONP20')">
              <mat-icon>payment</mat-icon>
              <span>Pago en línea</span>
            </a>
            <a mat-list-item [routerLink]="'/pending-paid'" *ngIf="tienePermiso('WPIMPP20')">
              <mat-icon>print</mat-icon>
              <span>Impresión relación de ingreso</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="tienePermiso('WSPROV20')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>medical_services</mat-icon>
              <span *ngIf="!soloIconos">Proveedores</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list *ngIf="!soloIconos">
            <a mat-list-item [routerLink]="'/healthcare-providers'" *ngIf="tienePermiso('LSPRSA20')">
              <mat-icon>monitor_heart</mat-icon>
              <span>Proveedores de salud</span>
            </a>
            <a mat-list-item [routerLink]="'/aps-providers'" *ngIf="tienePermiso('LSPAPS20')">
              <mat-icon>phone_in_talk</mat-icon>
              <span>Proveedores de APS</span>
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="tienePermiso('WSRPRI20')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>assignment</mat-icon>
            <span>Reportes de Primas</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a class="letras" mat-list-item [routerLink]="'/prin-cob'" *ngIf="tienePermiso('LSPRIC20')">
              <mat-icon>how_to_reg</mat-icon>Primas cobradas
            </a>
            <a class="letras" mat-list-item [routerLink]="'/prin-cob-ev'" *ngIf="tienePermiso('REPPRICO')">
              <mat-icon>how_to_reg</mat-icon>Primas cobradas
            </a>
            <a class="letras" mat-list-item [routerLink]="'/prin-pen'" *ngIf="tienePermiso('WPRIP20')">
              <mat-icon>how_to_reg</mat-icon>Primas pendientes
            </a>
            
            <!-- PRIMAS PENDIENTES POR EJECUTIVO, PRUEBAS (REPPRIPE) -->
            <a class="letras" mat-list-item [routerLink]="'/prin-pen-ev'" *ngIf="tienePermiso('REPPRIPE')">
              <mat-icon>how_to_reg</mat-icon>Primas pendientes por ejecutivo
            </a> 
              
            <a class="letras" mat-list-item [routerLink]="'/prin-emit'" *ngIf="tienePermiso('LSPRIE20')">
              <mat-icon>how_to_reg</mat-icon>Primas emitidas
            </a>
            <a class="letras" mat-list-item [routerLink]="'/cotiz-emit'" *ngIf="tienePermiso('REPCOTEM')">
              <mat-icon>how_to_reg</mat-icon>Cotización emitidas
            </a>
            <a class="letras" mat-list-item [routerLink]="'/lis-pre-ren'" *ngIf="tienePermiso('LSPRER20')">
              <mat-icon>how_to_reg</mat-icon>Pre-Renovación
            </a>
            <a class="letras" mat-list-item [routerLink]="'/prin-ren'" *ngIf="tienePermiso('LSRENO20')">
              <mat-icon>how_to_reg</mat-icon>Renovadas
            </a>
            <a class="letras" mat-list-item [routerLink]="'/prin-dev'" *ngIf="tienePermiso('LSANUD20')">
              <mat-icon>how_to_reg</mat-icon>Anuladas/Devueltas
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="tienePermiso('WSRGSC20')">
          <mat-expansion-panel-header>
            <mat-panel-title>
            <mat-icon>work_outline</mat-icon>
              <span>Gestión Comercial</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list>
            <a class="letras" mat-list-item [routerLink]="'/commisions'" *ngIf="tienePermiso('WREFCO20')">
              <mat-icon>how_to_reg</mat-icon>Consulta de comisiones
            </a>
            <a class="letras" mat-list-item [routerLink]="'/referencer'" *ngIf="tienePermiso('WSRECB20')">
              <mat-icon>how_to_reg</mat-icon>Referencia comercial
            </a>
            <a class="letras" mat-list-item [routerLink]="'/arc'" *ngIf="tienePermiso('WREPAR20')">
              <mat-icon>how_to_reg</mat-icon>Reporte ARC
            </a>
          </mat-nav-list>
        </mat-expansion-panel>

        <mat-expansion-panel *ngIf="tienePermiso('WSGUSU20')">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>group</mat-icon>
              <span *ngIf="!soloIconos">Gestión Usuarios</span>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-nav-list *ngIf="!soloIconos">
            <a mat-list-item [routerLink]="'/panel-admin'">
              <mat-icon *ngIf="!soloIconos">admin_panel_settings</mat-icon>
              <span>Administrar Perfiles</span>
            </a>
            
            <a mat-list-item [routerLink]="'/key-change'" *ngIf="tienePermiso('WACBCL20')">
              <mat-icon>how_to_reg</mat-icon>
              <span>Cambiar clave</span>
            </a>

          </mat-nav-list>
        </mat-expansion-panel>
      </mat-accordion>
      <a mat-list-item [routerLink]="'/download-area'" *ngIf="tienePermiso('WSGZONA2')">
        <mat-icon>cloud_download</mat-icon>
        <span *ngIf="!soloIconos">Zona de Descarga</span>
      </a>
      <a mat-list-item class="solo letras principal-options" *ngIf="url != '/login' && true" (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span *ngIf="!soloIconos">Salir</span>
      </a>
    </mat-nav-list>
    <div class="sidebar-bottom"></div>
  </mat-sidenav>

  <!-- <mat-sidenav-content [ngStyle]="{'margin-left': soloIconos ? '80px' : ''}"> -->
  <mat-sidenav-content [ngStyle]="{'margin-left': (isHandset$ | async) ? '0' : (soloIconos ? '85px' : '350px')}">
    
    <!-- <mat-toolbar class="toolbar-inside-content" *ngIf="url !== '/'"> -->
    <mat-toolbar class="toolbar-inside-content" *ngIf="(isHandset$ | async) || (url !== '/')">
      <button mat-icon-button (click)="drawer.toggle()" *ngIf="isHandset$ | async">
      <mat-icon>menu</mat-icon>
    </button>
      <!-- <div class="linea-toolbar"></div>  -->
      <ng-container *ngIf="soloIconos || (isHandset$ | async)">
        <div class="toolbar-welcome" *ngFor="let usuario of datos">
          <img class="avatar-img" src="assets/images/user.png" alt="Avatar" />
          <span class="welcome-user">{{ usuario.NOMBRE }}</span>
        </div>
      </ng-container>
    </mat-toolbar>
    <div class="main-content" content >
      <ng-content></ng-content>
    </div>
    <!-- <app-footer></app-footer> -->
  </mat-sidenav-content>
</mat-sidenav-container>
